import { ITutorialPassos, MensagensPadrao } from "../../../../Components/AdicionarAjuda";

export const IDs = {
    formularioDeFiltro: "formulario-de-filtros-subgrupo-do-estoque",

    filtroDeCodigoInterno: "campo-codigo-interno-filtros-subgrupo-do-estoque",
    filtroDeDescricao: "campo-descricao-filtros-subgrupo-do-estoque",
    filtroDeGrupo: "campo-grupo-filtros-subgrupo-do-estoque",
    filtroDeAtivo: "campo-ativo-filtros-subgrupo-do-estoque",

    botaoListar: "botao-listar-subgrupos-do-estoque",
    botaoAdicionar: "botao-adicionar-subgrupo-do-estoque",
}

export const Classes = {
    botaoEditar: "botao-editar-subgrupo-do-estoque",
    botaoDesativar: "botao-desativar-subgrupo-do-estoque",
}


export const ConsultarSubgrupo: ITutorialPassos = {
    steps: [
        { ...MensagensPadrao.filtros.apresentacao, target: () => document.getElementById(IDs.formularioDeFiltro)! },
        { ...MensagensPadrao.filtros.codigoInterno, target: () => document.getElementById(IDs.filtroDeCodigoInterno)! },
        { ...MensagensPadrao.filtros.descricao, target: () => document.getElementById(IDs.filtroDeDescricao)! },
        {
            title: "Filtro de grupo",
            description: `Caso deseje buscar somente por subgrupos que fazem parte de um determinado grupo, indique no campo "Grupo".`,
            target: () => document.getElementById(IDs.filtroDeGrupo)!,
        },
        { ...MensagensPadrao.filtros.ativo, target: () => document.getElementById(IDs.filtroDeAtivo)! },
        { ...MensagensPadrao.filtros.botaoListar, target: () => document.getElementById(IDs.botaoListar)! },
    ]
}

export const AdicionarSubgrupo: ITutorialPassos = {
    steps: [
        { ...MensagensPadrao.adicionar.entrada, target: () => document.getElementById(IDs.botaoAdicionar)! },
    ]
}

export const EditarSubgrupo: ITutorialPassos = {
    steps: [
        { ...MensagensPadrao.alterar.editar, target: () => document.querySelector('.' + Classes.botaoEditar)! },
    ]
}

export const DesativarSubgrupo: ITutorialPassos = {
    steps: [
        { ...MensagensPadrao.alterar.desativar, target: () => document.querySelector('.'+ Classes.botaoDesativar)! },
    ]
}